import {
    post
} from './request';

import { serverApiUrl } from '../config/server';

import getuserinfo from './getUserInfo'

import jsCookie from 'js-cookie';

export default async (account, password) => {
    try {
        let res = await post(`${serverApiUrl}/User`, {
            account,
            password
        })
        let data = res.data;
        if (data.success) {
            jsCookie.set('token', data.token);
        }
        await getuserinfo()
        return data;
    } catch (e) {
        console.log(e)
        return Promise.reject({
            code: -1,
            msg: '登录失败'
        });
    }

}